import fetchData from "../fetcher";
import { ResendActivationPayload } from "./types";
import { useMutation } from "@tanstack/react-query";

export const useResendActivation = () => {
    const { mutateAsync, data, isPending, error, isError } = useMutation({
        mutationKey: ["resendActivation"],
        mutationFn: (body: ResendActivationPayload) => fetchData<string, ResendActivationPayload>("/iam/v4/auth/resend-activation", { body, method: "POST" }),
    });

    return { ResendActivation: mutateAsync, data, isPending, error, isError };
}